export default __webpack_public_path__ + "static/GoP-98f4073c6959c4f7a8a2e15bea071e35.jpg";